import { defineStore } from "pinia";

export const useOutStateModelStore = defineStore('outStateModel', {
    state: () => ({
        outStateModel: {},
        outStateModels: [],
        outStateModelsSelect: [],
        loading: false,
    }),
    actions: {
        setLoading(state, loading) {
            state.loading = loading
        },
        setOutStateModel(outStateModel) {
            this.outStateModel = outStateModel
        },
        setOutStateModelsSelect(outStateModelsSelect) {
            this.outStateModelsSelect = outStateModelsSelect
        },
        setOutStateModels(outStateModels) {
            this.outStateModels = outStateModels
        },
        addOutStateModel(outStateModel) {
            this.outStateModels.unshift(outStateModel)
        },
        updateOutStateModel(outStateModel) {
            let index = this.outStateModels.findIndex(cl => cl.id === outStateModel.id)
            this.outStateModels.splice(index, 1, outStateModel)
        },
        deleteOutStateModel(outStateModel) {
            let index = this.outStateModels.findIndex(cl => cl.id === outStateModel.id)
            this.outStateModels.splice(index, 1)
        },
    },
});